<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
export default {
    name: "EmailTemplate",
    data() {
        return {
            msg: 'Template Here',
        }
    },
}
</script>

<style scoped>

</style>
